import { RESET_CARD_SUGGEST } from '../types';

export default function resetSuggest() {
  return { type: RESET_CARD_SUGGEST };
}
